module.exports = __webpack_public_path__ + "img/krathong_9.b03b23cc.png";